// Localização: /frontend/src/components/Management/VincularEquipamentoModal.js (versão 0.0.1)

import React, { useState, useEffect } from 'react';
// 🛑 Modal removido, pois será envolvido pelo Modal.js em EquipamentoPage
// import Modal from '../UI/Modal';
import PrimaryButton from '../Common/PrimaryButton';
import { usePacientes } from '../../hooks/usePacientes'; // Assumindo que você tem este hook
import LoadingIndicator from '../Common/LoadingIndicator';

/**
 * Formulário para vincular um equipamento a um paciente (Conteúdo para o Modal.js).
 * @param {function} onClose - Função para fechar o modal.
 * @param {function} onSubmit - Função chamada ao vincular (vincularEquipamento do hook).
 * @param {object} equipamento - O equipamento a ser vinculado.
 */
// 🛑 Props isOpen e title removidas
const VincularEquipamentoContent = ({ onClose, onSubmit, equipamento }) => {
    // Busca a lista de pacientes (apenas os nomes e IDs)
    const { pacientes, loading: loadingPacientes, fetchPacientes } = usePacientes();
    const [selectedPacienteId, setSelectedPacienteId] = useState('');
    const [formError, setFormError] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false); // Novo estado de loading

    useEffect(() => {
        if (equipamento) { // Verifica se há equipamento antes de abrir/fazer fetch
            fetchPacientes(); // Recarrega os pacientes sempre que a prop 'equipamento' muda (e o modal abre)
            setSelectedPacienteId(''); // Reseta a seleção
            setFormError(null);
        }
    }, [equipamento, fetchPacientes]); // Depende do equipamento para saber quando reabrir

    if (!equipamento) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormError(null);

        if (!selectedPacienteId) {
            setFormError('Selecione um paciente para vincular o equipamento.');
            return;
        }

        setIsSubmitting(true);
        // Chama a função onSubmit (do useEquipamentos)
        const result = await onSubmit(selectedPacienteId, equipamento.id);
        setIsSubmitting(false);

        if (result.success) {
            onClose();
        } else {
            setFormError(result.message); // Exibe erro da API
        }
    };

    // 🛑 Retorna apenas o conteúdo do formulário (sem o componente Modal)
    return (
        <form onSubmit={handleSubmit} className="space-y-4"> {/* Removido o padding, pois o Modal.js já tem p-6 */}
            
            {formError && (
                <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative text-sm" role="alert">
                    {formError}
                </div>
            )}

            <div className="text-sm text-gray-600">
                <p className="font-semibold">Equipamento:</p>
                <p className="font-medium text-gray-800">{equipamento.nome_equipamento} ({equipamento.numero_serie})</p>
            </div>

            <div>
                <label htmlFor="paciente_id" className="block text-sm font-medium text-gray-700">
                    Selecionar Paciente <span className="text-red-500">*</span>
                </label>
                {loadingPacientes ? (
                    <LoadingIndicator message="Carregando pacientes..." />
                ) : (
                    <select
                        name="paciente_id"
                        id="paciente_id"
                        value={selectedPacienteId}
                        onChange={(e) => setSelectedPacienteId(e.target.value)}
                        required
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500 sm:text-sm"
                    >
                        <option value="">-- Selecione um Paciente --</option>
                        {pacientes.map(paciente => (
                            <option key={paciente.id} value={paciente.id}>
                                {paciente.nome_completo}
                            </option>
                        ))}
                    </select>
                )}
            </div>

            <div className="pt-4 border-t mt-4 flex justify-end">
                <PrimaryButton type="submit" disabled={isSubmitting || loadingPacientes}>
                    {isSubmitting ? 'Vinculando...' : 'Vincular'}
                </PrimaryButton>
            </div>
        </form>
    );
};

export default VincularEquipamentoContent; // Renomeado para refletir o novo propósito